<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row d-flex justify-content-between">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="font-size-18 fa-solid fa-users primary-color" aria-hidden="true" style="font-size: 21px; margin-right: 3px;"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
            <p class="my-2 mb-0">Counselor : <b>{{ selectedCounselorName }}</b></p>
          </div>
          <div class="d-flex align-items-center pl-2 pl-sm-0" style="gap:8px;">
            <b-button title="View Counselor meetings" class="bg-transparent border-0 p-0 d-flex align-items-center justify-content-center" @click="openApp(whereFilter.counsellor_id, 'spcm_analytics_counselor_meetings')">
              <i class="fa-solid fa-arrow-up-right-from-square primary-color font-size-18"></i>
            </b-button>
            <div v-if="spcmObjList && Array.isArray(spcmObjList) && spcmObjList.length > 0" class="bg-white shadow-sm rounded-5 p-2 d-flex align-items-center justify-content-center">
              <i :title="csvTitle" class="fa-solid fa-file-csv primary-color pointer" style="font-size:20px;" @click="spcmCounselorStudentsList(false, true)"></i>
            </div>
          </div>
        </div>
        <div class="iq-card row p-3" >
          <b-col>
            <b-row class="col-12 col-xl-10">
              <b-col class="col-12 mb-3">
                <b-form-input
                  id="search"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"
                  @input="searchFromBackend">
                </b-form-input>
              </b-col>
            </b-row>

            <b-row class="col-12 mb-2">
              <!-- Counselor Name Filter -->
              <b-col class="mb-2 col-12 col-sm-4 col-lg-3">
                <select v-model="whereFilter.counsellor_id" class="form-control" @change="setCounsellor" v-if="counsellorObjList.length > 0" title="Counselor List">
                  <option :value="null" disabled>Choose Counselor</option>
                  <option v-for="(counsellor, index) of sortedCounsellorList" :key="(index+1)" :value="counsellor.counsellor_user_id">
                    {{counsellor.user_name}}
                  </option>
                </select>
              </b-col>
              <!-- Counselor Name Filter -->

              <!-- counselor type filter -->
              <b-col class="mb-2 col-12 col-sm-4 col-lg-3">
                <select v-model="whereFilter.counselorType" class="form-control" @change="handleFilterChange()">
                  <option value="all">All</option>
                  <option value="strategist">Strategist</option>
                  <option value="non_strategist">Non-Strategist</option>
                </select>
              </b-col>
                <!-- counselor type filter -->

              <!-- SPCM Category Ex. GIDE ONE, EXCLUSIVE Etc -->
              <b-col class="mb-2 col-12 col-sm-4 col-lg-3">
                <select v-model="whereFilter.spcm_category" class="form-control" @change="handleFilterChange()">
                  <option :value="null" disabled>Choose Category</option>
                  <option :value=null>All</option>
                  <option v-for="(category, index) of SPCM_CATEGORY_LIST" :key="(index+1)" :value="category?.spcm_category">
                    {{category?.spcm_category}}
                  </option>
                </select>
              </b-col><!-- SPCM Category -->

              <!-- Counselling Status -->
              <b-col class="mb-2 col-12 col-sm-4 col-lg-3">
                <select v-model="whereFilter.spcm_state" class="form-control" @change="handleFilterChange()">
                  <option :value="null" disabled>Choose Status</option>
                  <option :value=null>All</option>
                  <option v-for="(state, index) of SPCM_STATE_LIST" :key="(index+1)" :value="index">
                    {{state}}
                  </option>
                </select>
              </b-col><!-- Counselling Status -->

              <!-- Class Filter -->
              <b-col class="mb-2 col-12 col-sm-4 col-lg-3">
                <select v-model="whereFilter.Class" class="form-control" @change="handleFilterChange()">
                  <option :value="null" disabled>Choose Class</option>
                  <option v-for="(item, index) in filteredClasses" :key="index+'OrgType'" :value="item.value">
                   {{ item.label }}
                  </option>
                </select>
              </b-col>
              <!-- Class Filter -->

              <!-- University Filter -->
              <!-- <b-col sm="4" md="4" lg="4" xl="4" class="mb-2">
                <multiselect for="validationmodule_name"
                  v-model="universityFilterObj"
                  :options="univFiltersList['org_name , org_id']"
                  placeholder= "Choose University"
                  track-by="org_id"
                  label="org_name"
                  @input="spcmCounselorStudentsList(false)"
                  class="secondary-color"
                  style="line-height:35px; background: transparent; border-radius: 30px; font-size: 14px"
                >
                  <span slot="noResult">University Not found</span>
                </multiselect>
              </b-col> -->
              <!-- University Filter -->
            </b-row>
          </b-col>
          <!-- Download CSV, Remove Filter button -->
          <!-- <b-col class="mb-2 col-12 col-lg-2 mb-3">
            <i class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove Filters" @click="removeAllFilter"></i>
          </b-col> -->
          <!-- Download CSV, Remove Filter button -->
        </div>
        <div :style="{ minHeight: (!spcmObjList || spcmObjList?.length === 0) ? '400px' : 'auto'}" class="iq-card row p-3 d-flex align-items-center">
          <b-col md="12" v-if="spcmObjList && Array.isArray(spcmObjList) && spcmObjList.length > 0">
            <b-table
              hover
              responsive
              :items="spcmObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template v-slot:cell(id)="data">
                <span style="display: block;width: 50px">{{spcmObjList.indexOf(data.item)+1}}</span>
              </template>

              <template v-slot:cell(user_name)="data">
                <span class="pointer" @click="viewDetails(`/user/${data.item.user_id}`)"> {{ data.item.user_name }}</span><br>
                <span><small>
                  Id:&nbsp;{{ data.item.user_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.user_id)"></i><br>
                  Email:&nbsp;{{ data.item.user_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Email" @click="doCopy(data.item.user_email)"></i><br>
                  Mobile:&nbsp;{{data.item.user_mobile}}
                </small></span><br>
              </template>

              <template v-slot:cell(grade)="data">
               <p>
                Class:&nbsp;{{ fixedClassName(data.item.edu_class_name) }}&nbsp;<br>
                Board: {{ data.item.board_name ?? "-" }}
              </p>
              </template>

              <template v-slot:cell(counselor_role)="data">
                <span>{{ data.item.counselor_role ?? "-" }}</span>
              </template>

              <template v-slot:cell(total_meetings)="data">
                <span>{{ data.item.total_meetings ?? "0" }}</span>
                <b-button title="View student meetings analytics" style="border: none;" class="bg-transparent p-0 pl-2" @click="redirectToSpcmAnalyticsStudentMeetings(data.item)"><i class="font-size-18 fa-solid fa-arrow-up-right-from-square primary-color"></i></b-button>
              </template>

              <template v-slot:cell(university)="data">
                <div v-if="data.item.university">
                  <span>{{ data.item.university }}</span><br>
                  <small>
                    <span>Course:&nbsp;{{ data.item.cour_name }}</span><br>
                    <span>Intake:&nbsp;{{ data.item.batch }}</span><br>
                    <span>Appl. Deadline:&nbsp;{{ data.item.org_application_deadline_forstudent && data.item.org_application_deadline_forstudent != "null" ? data.item.org_application_deadline_forstudent : "-" }}</span><br><br>
                  </small>
                </div>
                <span v-else>-</span>
              </template>
              <template v-slot:cell(parent_details)="data">
                <span>
                  {{ data.item.parent_name }}<br>
                  <small>
                  Email:&nbsp;{{ data.item.parent_email }}<br>
                  Mobile:&nbsp;{{data.item.parent_mobile}}
                  </small>
                </span>
              </template>
              <template v-slot:cell(exam_name)="data">
                <div v-for="(examObj, examName) in getProgramAndTest(data.item.exam_name)" :key="examName" class="mb-0">
                  <div class="mb-1 p-0">
                    <span>
                      {{ examObj.exam_name }} <span v-if="examObj.subject_name">({{ examObj.subject_name }})</span>: {{ examObj.total_score }}
                    </span>
                    <small>{{ examObj.exam_date }}</small><br>
                  </div>
                </div>
              </template>

              <template v-slot:cell(spcm_state)="data">
                <b-badge v-if="data.item.spcm_state" class="text-wrap pointer" :style="getCounsellingStateColorCode(data.item.spcm_state)">{{ SPCM_STATE_LIST[data.item.spcm_state] }}</b-badge>
              </template>

              <template v-slot:cell(ms_country_strategy)="data">
                {{data.item.ms_country_strategy ? data.item.ms_country_strategy : "--"}}
              </template>

              <template v-slot:cell(spcm-categpry)="data">
                  <div class="mt-2">
                  <b-badge class="text-wrap pointer mr-4" :style="'background:'+getBgFor(data.item.spcm_category)">{{ data.item.spcm_category }}</b-badge>
                </div>
              </template>

              <template v-slot:cell(trems_conditions)="data">
                <div class="mt-2">
                  <b-badge variant="success" v-if="data.item.spcm_tnc == '1'" class="mb-2 ml-1" title="Counseling TnC Accepted">
                    Accepted
                  </b-badge>
                  <b-badge style="background: #e5252c!important" v-if="data.item.spcm_tnc == '0'" title="Counseling TnC Not Accepted"  class="mb-2 ml-1">
                    Not Accepted
                  </b-badge>
                </div>
              </template>

              <template v-slot:cell(strategist)="data">
                <span>{{ data.item.counsellor_name }}</span>
              </template>
              <template v-slot:cell(counsellor_team)="data">
                <b-button style="border: none;" class="bg-transparent p-0" @click="spcmStudentCounsellorTeam(data.item)"><i class="font-size-18 fa fa-users primary-color" title="View Team" aria-hidden="true"></i></b-button>
              </template>
              <template v-slot:cell(sales_person)="data">
                 {{ data.item.sales_user_id ? data.item.sales_user_name : " - "}}
              </template>
              <template v-slot:cell(created_on)="data">
                {{ data.item.created_on | dateFormatDDMMYY }}
              </template>
            </b-table>
            <div class="d-flex align-items-center mt-3 py-3">
              <b-col v-if="(currentBatchNo * dataPerPage) < totalDataCount" sm="7" md="8" class="my-1">
                  <b-btn variant="primary" @click="loadMoreData">Load More</b-btn>
              </b-col>
            </div>
          </b-col>
          <b-col v-else-if="spcmObjList && Array.isArray(spcmObjList) && spcmObjList.length === 0">
            <h5 class="text-secondary text-center">No matching students found.</h5>
          </b-col>
          <b-col v-else class="text-center py-5">
            <b-spinner variant="primary" class="align-middle"></b-spinner>
            <h5 class="mt-3 text-primary">Loading students...</h5>
            <p class="text-muted mb-0">Please wait while student records are being loaded.</p>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <!--Spcm Student Counsellor Team -->
    <b-modal
      v-model="showModelSpcmStudentCounsellorTeam"
      scrollable
      :title="cvSpcmStudentCounsellorTeamModalHeader"
      size="xxl"
      hide-footer>
      <SpcmStudentCounsellorTeam :propStudentCounselorTeam="true" :propOpenedInModal="true" :propStudentCounsellorObj="StudentCounsellorTeamObj" @emitCloseStudentCounsellorTeamModal="closeStudentCounsellorTeamModal" />
    </b-modal><!-- Spcm Student Counsellor Team -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg">
      </div>
    </b-toast>
  </b-container>
</template>
<script>
import { socialvue } from "../../../config/pluginInit.js"
import { Spcms } from "../../../FackApi/api/Spcm.js"
import { SpcmCounsellors } from "../../../FackApi/api/SpcmCounsellor.js"
import ColorCodes from "../../../Utils/colorcodes.js"
import Utility from "../../../Utils/utility.js"
import Class from "../../../FackApi/json/Class.json"
import SpcmStudentCounsellorTeam from "./SpcmStudentCounsellorTeam.vue"

export default {
  name: "SpcmAnalyticsCounselorStudents",
  components: {
    SpcmStudentCounsellorTeam
  },
  data () {
    return {
      cvCardTitle: "Counselor's Student Report",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Counselor's Student Report",
      sortBy: "name",
      sortDesc: false,
      columns: [],
      spcmObjList: null,
      currentBatchNo: 1,
      dataPerPage: 25,
      doCopy: Utility.doCopy,
      whereFilter: {
        spcm_category: null,
        spcm_state: null,
        counsellor_id: null,
        Class: null,
        counselorType: "strategist"
      },
      SPCM_STATE_LIST: {},
      SPCM_CATEGORY_LIST: {},
      totalDataCount: 0,
      SPCM_STATE_COLORCODE_LIST: {},
      counsellorObjList: [],
      cvSearchText: "Type to Search",
      search_param: "",
      Class: Class,
      StudentCounsellorTeamObj: null,
      showModelSpcmStudentCounsellorTeam: false,
      cvSpcmStudentCounsellorTeamModalHeader: "Student Counselor Team",
      selectedCounselorName: null,
      csvTitle: "Download counselor Students analytics"
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    },
    sortedCounsellorList () {
      return [...this.counsellorObjList].sort((a, b) =>
        a.user_name.localeCompare(b.user_name)
      )
    },
    filteredClasses () {
      return Object.values(this.Class).map(c => {
        return {
          value: c,
          label: c === "Other" ? "All" : this.fixedClassName(c)
        }
      })
    }
  },
  async mounted () {
    socialvue.index()
    this.setUserView()
    this.spcmCategory()
    this.spcmStateList()
    this.getCounselorFilterList()

    // Set counselor from URL parameter if available
    if (this.$route.params.counselor_id) {
      this.whereFilter.counsellor_id = this.$route.params.counselor_id
    }
    this.spcmCounselorStudentsList()
  },
  methods: {
    /**
     * openApp
     */
    openApp (counselorId, path) {
      if (path && counselorId) {
        this.$router.push(`/${path}/${counselorId}`)
      }
    },
    /**
     * spcmCategory
     */
    async spcmCategory () {
      try {
        let spcmCategoryListResp = await Spcms.spcmCategoryList(this)
        if (spcmCategoryListResp.resp_status) {
          let categoryObjList = spcmCategoryListResp.resp_data.data
          this.SPCM_CATEGORY_LIST = categoryObjList
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmCategoryList() and Exception:", err.message)
      }
    },
    /**
     * spcmStateList
     */
    async spcmStateList () {
      try {
        let spcmStateListResp = await Spcms.spcmStateList(this)
        if (spcmStateListResp.resp_status) {
          let stateObjList = spcmStateListResp.resp_data.data
          for (let stateObj of stateObjList) {
            this.SPCM_STATE_LIST[stateObj.state_id] = stateObj.state
            this.SPCM_STATE_COLORCODE_LIST[stateObj.state_id] = stateObj.state_color_code
          }
        }
      }
      catch (err) {
        console.error("Exception occurred at spcmStateList() and Exception:", err.message)
      }
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.spcmCounselorStudentsList(true)
    },
    /**
     * spcmCounselorStudentsList
     */
    async spcmCounselorStudentsList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.downloadCsv = downloadCsv

        let spcmListResp = await Spcms.spcmCounselorStudentsList(this, this.whereFilter)
        if (spcmListResp.resp_status) {
          if (downloadCsv) {
            window.open(spcmListResp.resp_csv_file_url)
            return
          }

          if (!loadViaLoadMore) {
            this.spcmObjList = [ ...spcmListResp.resp_data.data ]
          }
          else {
            this.spcmObjList = [ ...this.spcmObjList, ...spcmListResp.resp_data.data ]
          }

          this.totalDataCount = spcmListResp.resp_data_total_count
        }
        else {
          this.toastMsg = spcmListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
          this.spcmObjList = []
        }
      }
      catch (err) {
        this.toastMsg = "Failed to fetch counselor students. Please try again."
        this.toastVariant = "danger"
        this.showToast = true
        this.spcmObjList = []
        console.error("Exception occurred at spcmCounselorStudentsList() and Exception:", err.message)
      }
    },
    /**
     * setUserView
     */
    setUserView () {
      switch (this.userData.user_role) {
        case "USERROLE11111":
          this.columns = [
            { label: "# ", key: "id", class: "text-left align-text-top w-50px", sortable: true },
            { label: "Student Info", key: "user_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Grade", key: "grade", class: "text-left align-text-top w-200px", sortable: true },
            { label: "Counselor role", key: "counselor_role", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Applications", key: "university", class: "text-left align-text-top w-300px", sortable: true },
            // { label: "course", key: "cour_name", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Application Deadline", key: "org_application_deadline_forstudent w-200px", class: "text-left align-text-top", sortable: true },
            // { label: "Intake", key: "batch", class: "text-left align-text-top w-150px", sortable: true },
            // { label: "Test Score", key: "exam_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Total Meetings", key: "total_meetings", class: "text-left align-text-top w-200px", sortable: true },
            { label: "Status", key: "spcm_state", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Country Strategy", key: "ms_country_strategy", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Parent Info", key: "parent_details", class: "text-left align-text-top w-260px", sortable: true },
            // { label: "Current Progress", key: "spcm_id", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Lead Strategist", key: "strategist", class: "text-left align-text-top w-200px", sortable: true },
            { label: "Counsellor Team", key: "counsellor_team", class: "text-left align-text-top w-200px", sortable: true },
            { label: "Joined Spcm On", key: "created_on", class: "text-left align-text-top w-200px", sortable: true },
            { label: "services ", key: "spcm-categpry", class: "text-left align-text-top", sortable: true },
            { label: "Terms", key: "trems_conditions", class: "text-left align-text-top", sortable: true },
            { label: "sales", key: "sales_person", class: "text-left align-text-top", sortable: true }
          ]
          break
        case "USERROLE11118":
          this.columns = [
            { label: "# ", key: "id", class: "text-left align-text-top w-50px", sortable: true },
            { label: "Student Info", key: "user_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Grade", key: "grade", class: "text-left align-text-top w-100px", sortable: true },
            { label: "Counselor role", key: "counselor_role", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Applications", key: "university", class: "text-left align-text-top w-300px", sortable: true },
            // { label: "course", key: "cour_name", class: "text-left align-text-top w-200px", sortable: true },
            // { label: "Application Deadline", key: "org_application_deadline_forstudent w-200px", class: "text-left align-text-top", sortable: true },
            // { label: "Intake", key: "batch", class: "text-left align-text-top w-150px", sortable: true },
            // { label: "Test Score", key: "exam_name", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Total Meetings", key: "total_meetings", class: "text-left align-text-top w-200px", sortable: true },
            { label: "Status", key: "spcm_state", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Country Strategy", key: "ms_country_strategy", class: "text-left align-text-top w-125px", sortable: true },
            { label: "Parent Info", key: "parent_details", class: "text-left align-text-top w-260px", sortable: true },
            // { label: "Current Progress", key: "spcm_id", class: "text-left align-text-top w-300px", sortable: true },
            { label: "Lead Strategist", key: "strategist", class: "text-left align-text-top w-175px", sortable: true },
            { label: "Counsellor Team", key: "counsellor_team", class: "text-left align-text-top w-200px", sortable: true },
            { label: "Joined Spcm On", key: "created_on", class: "text-left align-text-top w-200px", sortable: true },
            { label: "services ", key: "spcm-categpry", class: "text-left align-text-top", sortable: true },
            { label: "Terms", key: "trems_conditions", class: "text-left align-text-top", sortable: true },
            { label: "sales", key: "sales_person", class: "text-left align-text-top", sortable: true }
          ]
      }
    },
    /**
     * fixedClassName
     */
    fixedClassName (className) {
      if (className == 0) {
        return "-"
      }
      else if (className == 13) {
        return "Graduation"
      }
      else if (className == 14) {
        return "Post Graduation"
      }
      else if (className == 15) {
        return "PhD"
      }
      else {
        return className
      }
    },
    /**
     * parse and get the data
     */
    getProgramAndTest (programs) {
      try {
        return JSON.parse(programs)
      }
      catch (e) {
        return {}
      }
    },
    /**
     * get Counselling State Color Code
     */
    getCounsellingStateColorCode (stateId) {
      if (stateId == 99) {
        return `vertical-align: middle; color: #FFF; background: orange !important;`
      }
      else if (stateId == 98) {
        return `vertical-align: middle; color: #FFF; background: #e5252c !important;`
      }
      else {
        return `vertical-align: middle; color: #FFF; background: ${this.SPCM_STATE_COLORCODE_LIST[stateId]} !important;`
      }
    },
    /**
     * getBgFor
     */
    getBgFor (category) {
      switch (category) {
        case "Partner":
        case "GIDE-PARTNER":
          return ColorCodes.getBgColor(24)
        case "GIDE-ONE":
          return ColorCodes.getBgColor(3)
        case "Premium":
        case "GIDE-EXCLUSIVE":
          return ColorCodes.getBgColor(10)
      }
    },
    /**
     * getCounselorFilterList
     */
    async getCounselorFilterList () {
      const counselorsListResp = await SpcmCounsellors.spcmCounsellorList()
      if (counselorsListResp.resp_status) {
        this.counsellorObjList = counselorsListResp.resp_data.data

        if (this.counsellorObjList && this.counsellorObjList.length > 0 && this.whereFilter.counsellor_id) {
          // setting counselor name
          const selectedCounselor = this.counsellorObjList.find(counselor => counselor.counsellor_user_id === this.whereFilter.counsellor_id)
          this.selectedCounselorName = selectedCounselor ? selectedCounselor.user_name : ""
        }
      }
    },
    /**
     * setCounsellor
    */
    async setCounsellor () {
      // Reset pagination when counselor changes
      this.currentBatchNo = 1

      // Update URL with selected counselor
      if (this.whereFilter.counsellor_id) {
        this.$router.push({
          name: this.$route.name,
          params: { counselor_id: this.whereFilter.counsellor_id }
        })
      }
      else {
        // Navigate without counselor_id parameter
        this.$router.push({
          name: this.$route.name,
          params: { counselor_id: undefined }
        })
      }

      this.spcmCounselorStudentsList()
    },
    /**
     * searchFromBackend
     */
    searchFromBackend () {
      if (this.search_param.length <= 1) {
        return
      }
      this.currentBatchNo = 1
      this.spcmCounselorStudentsList()
    },
    /**
     * viewDetails
     */
    viewDetails (path) {
      this.$router.push(path)
    },
    /**
     * spcmStudentCounsellorTeam
     */
    spcmStudentCounsellorTeam (item) {
      try {
        this.StudentCounsellorTeamObj = item
        this.showModelSpcmStudentCounsellorTeam = true
      }
      catch (err) {
        console.error("Exception occurred at spcmStudentCounsellorTeam() and Exception:", err.message)
      }
    },
    /**
     * closeStudentCounsellorTeamModal
     */
    closeStudentCounsellorTeamModal (updatedData) {
      this.showModelSpcmStudentCounsellorTeam = false
    },
    /**
     * handleFilterChange
     */
    handleFilterChange () {
      this.currentBatchNo = 1
      this.spcmCounselorStudentsList()
    },
    /**
     * redirectToSpcmAnalyticsStudentMeetings
     */
    redirectToSpcmAnalyticsStudentMeetings (item) {
      if (!item.spcm_id) {
        this.toastMsg = "Something went wrong. Cannot redirect to meetings analytics."
        this.toastVariant = "danger"
        this.showToast = true
        return
      }
      this.$router.push(`/spcm_analytics_student_meetings/${item.spcm_id}`)
    }
  },
  watch: {
    "$route.params.counselor_id" (newCounselorId) {
      if (newCounselorId) {
        this.whereFilter.counsellor_id = newCounselorId
        // setting counselor name
        const selectedCounselor = this.sortedCounsellorList.find(counselor => counselor.counsellor_user_id === newCounselorId)
        this.selectedCounselorName = selectedCounselor ? selectedCounselor.user_name : ""

        this.currentBatchNo = 1
        this.spcmCounselorStudentsList()
      }
    }
  }
}
</script>
